"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketEncryptionInput_1 = require("./DeleteBucketEncryptionInput");
var DeleteBucketEncryptionOutput_1 = require("./DeleteBucketEncryptionOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketEncryption = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketEncryption",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?encryption"
    },
    input: {
        shape: DeleteBucketEncryptionInput_1.DeleteBucketEncryptionInput
    },
    output: {
        shape: DeleteBucketEncryptionOutput_1.DeleteBucketEncryptionOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketEncryption.js.map